module.exports = __webpack_public_path__ + "img/icon_dean_home_alert_icon_8.e04e89b3.png";